var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          staticClass: "edit-form-item",
          attrs: {
            "label-width": _vm.labelWidth,
            required: _vm.config.required,
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "edit-form-item-label" },
                    [
                      _c("div", {
                        staticClass: "q-number-ipt",
                        style: {
                          width:
                            _vm.currentItem.questionNumber.length <= 2
                              ? "20px"
                              : "fit-content",
                        },
                        attrs: { contenteditable: true },
                        domProps: {
                          textContent: _vm._s(_vm.currentItem.questionNumber),
                        },
                        on: {
                          blur: _vm.handleChangeQNumber,
                          input: _vm.filterQNumberInput,
                        },
                      }),
                      _c("span", { staticStyle: { "margin-right": "4px" } }, [
                        _vm._v("."),
                      ]),
                      _vm.config.showLabel
                        ? _c("dt-tinymce", {
                            staticStyle: {
                              "min-width": "220px",
                              "word-break": "break-all",
                            },
                            attrs: { inline: true },
                            on: { change: _vm.handleChangeLabel },
                            model: {
                              value: _vm.config.label,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "label", $$v)
                              },
                              expression: "config.label",
                            },
                          })
                        : _vm._e(),
                      _vm.currentItem.examConfig &&
                      _vm.currentItem.examConfig.score &&
                      _vm.currentItem.examConfig.enableScore
                        ? _c("span", { staticClass: "text-after" }, [
                            _vm._v(
                              " (最高分值:" +
                                _vm._s(_vm.currentItem.examConfig.score) +
                                " 分) "
                            ),
                            _vm.currentItem.examConfig.answer
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#13ce66",
                                      "margin-left": "20px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " 正确答案：" +
                                        _vm._s(_vm.getExamAnswer) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form-item",
            { staticClass: "description_input" },
            [
              _c("el-input", {
                attrs: { placeholder: "问题描述" },
                model: {
                  value: _vm.config.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "description", $$v)
                  },
                  expression: "config.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "edit-form-item",
          attrs: {
            "label-width": _vm.labelWidth,
            required: _vm.config.required,
          },
        },
        [
          _vm.componentList.includes(_vm.currentItem.typeId)
            ? [
                _c(_vm.currentItem.config.tag, {
                  tag: "component",
                  staticClass: "form-item-component",
                  attrs: { item: _vm.currentItem, mode: "design" },
                  on: {
                    input: _vm.handleDefaultValue,
                    "upload-option-img": _vm.handleUploadImg,
                  },
                  model: {
                    value: _vm.currentItem.config.defaultValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentItem.config, "defaultValue", $$v)
                    },
                    expression: "currentItem.config.defaultValue",
                  },
                }),
              ]
            : [
                _c(
                  _vm.currentItem.config.tag,
                  _vm._b(
                    {
                      tag: "component",
                      staticClass: "form-item-component",
                      attrs: { item: _vm.currentItem, mode: "design" },
                      on: { input: _vm.handleDefaultValue },
                      model: {
                        value: _vm.currentItem.config.defaultValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.currentItem.config, "defaultValue", $$v)
                        },
                        expression: "currentItem.config.defaultValue",
                      },
                    },
                    "component",
                    Object.assign({}, _vm.currentItem),
                    false
                  )
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }